// 获取全国的景点信息
import { commonReduxGenerator } from '@/util/reduxGenerator/index'
import { url, api } from '@/config/api'

export const {
							 reducer,
	
							 common_success: success,
							 common_error: error,
							 common_reset: reset,
							 common_loading: loading,
							 common_loaded: loaded,
	
							 getNational
						 } = commonReduxGenerator({
  type: 'national',
  api: url + api.getNational
})
